import TaskContainer from "../../../Components/Applications/Task/TaskContainer";

const Task = () => {
  return <TaskContainer />;
};

export default Task;
